import {
  deleteRequest,
  getRequest,
  patchRequest,
  postRequest,
} from '@/shared/utils/requests';
import {createSlice} from '@reduxjs/toolkit';
import {handleAsyncRequest} from '../utils';
import {RECORDS_PER_PAGE} from '@/shared/constants/customOvernights';

const initialState = {
  error: null,
  isLoading: false,
  list: [],
  currentData: [],
};

export const slice = createSlice({
  name: 'customOvernights',
  initialState,
  reducers: {
    hasError: (state, action) => {
      state.error = action.payload;
    },
    startLoading: (state) => {
      state.isLoading = true;
    },
    stopLoading: (state) => {
      state.isLoading = false;
    },
    setCustomOvernightsList: (state, action) => {
      state.list = action.payload;
    },
    setCurrentData: (state, action) => {
      state.currentData = action.payload;
    },
    addCustomOvernightToList: (state, action) => {
      state.list.push(action.payload);
    },
    updateCustomOvernight: (state, action) => {
      const foundIndex = state.list.findIndex(
        ({id}) => id == action.payload.id
      );

      if (foundIndex !== -1) {
        state.list[foundIndex] = {
          ...state.list[foundIndex],
          ...action.payload,
        };
      }
    },
    deleteCustomOvernight(state, action) {
      state.list = state.list?.filter(({id}) => id !== action.payload);
    },
  },
});

export default slice.reducer;
const actions = slice.actions;

// Export actions
export const {
  hasError,
  startLoading,
  stopLoading,
  setCustomOvernightsList,
  setCurrentData,
} = actions;

// Selectors
export const getAllCustomOvernights = (state) => state.customOvernights.list;

export const getCustomOvernightById =
  ({customOvernightId}) =>
  (state) =>
    state.customOvernights.list.find(({id}) => {
      return id === customOvernightId;
    });

// Fetch CustomOvernights
export const fetchCustomOvernights = () => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: getRequest,
    endpoint: '/custom-overnights',
    toastMessage: {success: {show: false}, error: {show: true}},
  });

  if (error) throw error;

  dispatch(actions.setCustomOvernightsList(body?.customOvernights));

  const overnightList = body?.customOvernights ?? [];

  const initialData = overnightList.slice(0, RECORDS_PER_PAGE);

  dispatch(actions.setCurrentData(initialData));
};

// Create Product
export const createNewCustomOvernight = (data) => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: postRequest,
    endpoint: '/custom-overnights',
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  else {
    dispatch(actions.addCustomOvernightToList(body?.customOvernight));
    return body?.customOvernight;
  }
};

export const updateCustomOvernight = (data) => async (dispatch) => {
  const {error, body} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: patchRequest,
    endpoint: `/custom-overnights/${data?.id}`,
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  else {
    dispatch(actions.updateCustomOvernight(body?.customOvernight));
    return body?.customOvernight;
  }
};

// Delete CustomOvernight
export const deleteCustomOvernight = (data) => async (dispatch) => {
  const {error} = await handleAsyncRequest({
    dispatch,
    actions,
    requestFn: deleteRequest,
    endpoint: `/custom-overnights/${data?.id}`,
    payload: data,
    toastMessage: {success: {show: true}, error: {show: true}},
  });

  if (error) throw error;
  else dispatch(actions.deleteCustomOvernight(data?.id));
};
